<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import defaultLogo from "@/assets/img/logo-ct-dark.png";
import defaultLogoWhite from "@/assets/img/logo-ct.png";
import { applyPageTitle } from "@/services/pageTitle";

const store = useStore();
const route = useRoute();
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
const tenantConfig = computed(() => store.state.tenantConfig)

const brandLogo = ref(defaultLogo);
const brandLogoWhite = ref(defaultLogoWhite);
const appBrandName = ref("Dashboard");

const getCurrentScreenName = () => {
  if (
    typeof route.meta?.screenName === "string" &&
    route.meta.screenName.trim()
  ) {
    return route.meta.screenName;
  }

  return typeof route.name === "string" ? route.name : undefined;
};

const applyTenantConfig = (config) => {
  applyPageTitle({
    appName: config?.appName,
    screenName: getCurrentScreenName(),
  });

  if (!config) {
    return;
  }

  if (config.logoUrl) {
    brandLogo.value = config.logoUrl;
    brandLogoWhite.value = config.logoUrl;
  }
  if (config.appName) {
    appBrandName.value = config.appName;
  }
};

onMounted(async () => {
  try {
    applyTenantConfig(tenantConfig.value);
  } catch (error) {
    console.error("Failed to fetch backoffice config", error);
  }
});
</script>
<template>
  <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-success'}`" />

  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl fixed-start ms-3"
    :class="`${layout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${sidebarType}`" id="sidenav-main">
    <div class="sidenav-header">
      <i class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true" id="iconSidenav"></i>

      <router-link class="m-0 navbar-brand" to="/">
        <img :src="darkMode || sidebarType === 'bg-default' ? brandLogoWhite : brandLogo
          " class="navbar-brand-img h-100" alt="main_logo" />

        <span class="ms-2 font-weight-bold me-2">{{ appBrandName }}</span>
      </router-link>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>
